import type { PlatformConfig } from '../app/core/models/platform.model';

export const environment = {
  production: false,
  platforms: [
    {
      id: 'trivolo',
      name: 'Trivolo',
      apiBaseUrl: 'https://api-dev.trivolo.com.br',
      enabled: true,
    },
    { id: 'taskeo', name: 'Taskeo', apiBaseUrl: '', enabled: false },
    { id: 'premmio', name: 'Premmio', apiBaseUrl: '', enabled: false },
  ] as PlatformConfig[],
};
